export async function getPostalPlace(
  postalCode: string
): Promise<string | null> {
  try {
    const response = await fetch(
      `https://ws.geonorge.no/adresser/v1/sok?fuzzy=false&postnummer=${postalCode}&treffPerSide=1&side=0&asciiKompatibel=true`
    );
    const data = await response.json();

    if (data.adresser && data.adresser.length > 0) {
      return data.adresser[0].poststed || "Ukjent";
    }

    return "Ukjent";
  } catch (error) {
    console.error("Klarte ikke hente poststed:", error);
    return "Ukjent";
  }
}
